import {
  extractAndFilterItemsOrProvideDefault,
  extractData,
  extractPropOrThrow,
} from "./utils";
import {
  IListInvoicesByBillingAccountQuery,
  IQueryListInvoicesByBillingAccountArgs,
} from "@/generated/types";
import { ApolloQueryResult } from "apollo-boost";
import Observable from "zen-observable";
import { watchInvoicesByBillingAccountQuery } from "@/api/invoice";

const parseInvoiceList = (
  value: ApolloQueryResult<IListInvoicesByBillingAccountQuery>,
) => {
  const invoicesByBillingAccount = extractPropOrThrow(
    extractData(value),
    "listInvoicesByBillingAccount",
  );
  return {
    ...invoicesByBillingAccount,
    items: extractAndFilterItemsOrProvideDefault(invoicesByBillingAccount).map(
      (invoice) => ({
        ...invoice,
        date: new Date(invoice.date).toLocaleDateString(),
        amountPaid: (invoice.amountPaid ?? 0) / 100,
      }),
    ),
  };
};

export function watchInvoicesByBillingAccount(
  variables: IQueryListInvoicesByBillingAccountArgs,
) {
  const { observable, ...rest } = watchInvoicesByBillingAccountQuery(variables);

  return {
    observable: observable.map(parseInvoiceList),
    ...rest,
  };
}

export type IInvoiceItem = (ReturnType<
  typeof watchInvoicesByBillingAccount
>["observable"] extends Observable<infer T>
  ? T
  : never)["items"][number];
